import { useSyncExternalStore } from 'react';
import {
  getMockAccount,
  getMockApplication,
  getMockDocuments,
  getMockLoan,
  getMockPaymentHistory,
  getMockPortalVersion,
  getMockRecentActivity,
  subscribeMockPortal,
} from './store';
import type {
  PortalAccountContact,
  PortalApplicationState,
  PortalDocumentItem,
  PortalLoanSummary,
  PortalPaymentHistoryItem,
} from './types';

export type MockPortalSnapshot = {
  loan: PortalLoanSummary;
  history: PortalPaymentHistoryItem[];
  recentActivity: PortalPaymentHistoryItem[];
  documents: PortalDocumentItem[];
  account: PortalAccountContact;
  application: PortalApplicationState;
};

let cachedVersion = -1;
let cachedSnapshot: MockPortalSnapshot | null = null;

function buildSnapshot(): MockPortalSnapshot {
  return {
    loan: getMockLoan(),
    history: getMockPaymentHistory(),
    recentActivity: getMockRecentActivity(3),
    documents: getMockDocuments(),
    account: getMockAccount(),
    application: getMockApplication(),
  };
}

/**
 * Must return the same object reference when the store has not changed,
 * or useSyncExternalStore will loop.
 */
function getSnapshot(): MockPortalSnapshot {
  const version = getMockPortalVersion();
  if (cachedSnapshot === null || version !== cachedVersion) {
    cachedVersion = version;
    cachedSnapshot = buildSnapshot();
  }
  return cachedSnapshot;
}

/** Re-subscribe when in-memory mock store changes (pay, account save, etc.). */
export function useMockPortal(): MockPortalSnapshot {
  return useSyncExternalStore(subscribeMockPortal, getSnapshot, getSnapshot);
}
